/**
 * Delivery drivers page shell — layout, nav, and section composition.
 * Section UI + logic: ./delivery-drivers/sections/DriverListSection.jsx
 * Page state: ./delivery-drivers/useDeliveryDrivers.js
 */
import React from 'react';
import '../../atomic/inputbox/InputBox.scss';
import '../storesettings-page/StoreSettings-Page.css';
import { DriverListSection } from './delivery-drivers/sections/DriverListSection';
import { useDeliveryDrivers } from './delivery-drivers/useDeliveryDrivers';

const DeliveryDriversPage = () => {
  const v = useDeliveryDrivers();

  const renderPanel = () => {
    switch (v.selectedId) {
      case '1':
      default:
        return (
          <DriverListSection
            drivers={v.dedicatedDrivers}
            kitchenName={v.kitchenName}
            isRefreshingKitchen={v.isRefreshingKitchen}
          />
        );
    }
  };

  return (
    <div className='store-settings-page'>
      <div className='store-settings-shell' style={{ maxWidth: 1400 }}>
        <aside className='store-settings-toc'>
          <div className='store-settings-toc-header'>Delivery Drivers</div>
          {v.sectionMeta.map((section) => {
            const { Icon } = section;
            const isActive = v.selectedId === section.id;
            return (
              <div
                key={section.id}
                className={
                  isActive
                    ? 'store-settings-toc-link store-settings-toc-link--active'
                    : 'store-settings-toc-link'
                }
                onClick={() => v.setSelectedId(section.id)}
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') v.setSelectedId(section.id);
                }}
              >
                <Icon sx={{ fontSize: 15, flexShrink: 0, opacity: isActive ? 1 : 0.7 }} />
                {section.title}
              </div>
            );
          })}
        </aside>

        <main
          className='store-settings-content'
          style={{ flex: '0 0 auto', alignSelf: 'flex-start', width: 'fit-content', padding: '0' }}
        >
          <div style={{ padding: 0 }}>{renderPanel()}</div>
        </main>
      </div>
    </div>
  );
};

export default DeliveryDriversPage;
